const toFrameRect = (
  el: HTMLElement,
): WallboardScreenshots.Rect | undefined => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  if (!width || !height) {
    return undefined;
  }
  const rect = el.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0) {
    return undefined;
  }
  return {
    x: rect.left / width,
    y: rect.top / height,
    width: rect.width / width,
    height: rect.height / height,
  };
};

// The video gadget placeholders on the page (see VideoGadgetPrintPlaceholder),
// as fractions of the viewport so the TV player can overlay the live videos on
// the screenshot at any screen size.
const collectVideoOverlays = (): WallboardScreenshots.VideoOverlay[] =>
  Array.from(document.querySelectorAll<HTMLElement>('[data-wallboard-video]'))
    .map((el) => ({
      storagePath: el.dataset.wallboardVideo ?? '',
      rect: toFrameRect(el),
    }))
    .filter(
      (video): video is WallboardScreenshots.VideoOverlay =>
        !!video.storagePath && !!video.rect,
    );

// A driver leaderboard's active progress track (DriverLeaderboardStage), so
// the TV player can animate the countdown to the next step over the still.
export const collectProgressOverlay = ():
  | WallboardScreenshots.ProgressOverlay
  | undefined => {
  const el = document.querySelector<HTMLElement>(
    '[data-wallboard-progress-from]',
  );
  if (!el) {
    return undefined;
  }
  const rect = toFrameRect(el);
  const from = Number(el.dataset.wallboardProgressFrom);
  const to = Number(el.dataset.wallboardProgressTo);
  if (!rect || !Number.isFinite(from) || !Number.isFinite(to)) {
    return undefined;
  }
  return { rect, from, to };
};

export default collectVideoOverlays;
